import React, { useEffect, useState,useRef,useContext ,useMemo,useCallback} from 'react';
import $ from 'jquery';
import axios from 'axios';
import styles from './css/user.module.css';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import { useParams ,useLocation} from 'react-router-dom';
import DataTable from "react-data-table-component";
import { useNavigate } from 'react-router-dom';
import ReactQuill from "react-quill-new";
import Select from 'react-select';
import "react-quill-new/dist/quill.snow.css";
import RefreshContext from './RefreshContext';
import {
  Box, 
   Button, 
  Select as MuiSelect,
  MenuItem, 
  Typography, 
  Tooltip, 
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Menu,
  ListItemIcon,Chip} from '@mui/material'; 
import { ArrowDropDown, ArrowDropUp, MoreVert as MoreVertIcon,DeleteOutline,DownloadOutlined ,EditOutlined, VisibilityOutlined, KeyboardArrowRight, FormatListBulleted } from '@mui/icons-material';

function CampaignList({campType}) {

const navigate = useNavigate();
const { refreshKey } = useContext(RefreshContext);
const isCampaignCandidateLineup = campType === '3';
const [stats,setStats] = useState([]);
const [showResultsModal, setShowResultsModal] = useState(false);
const [results, setResults] = useState(null);
const [requirement, setRequirement] = useState(null);
const [detail, setDetail] = useState([]);


const { aid} = useParams();
const [staff, setStaff] = useState([]);
const [team, setTEam] = useState([]);
const [ivr,setIvr] = useState("");const [newloading,setNewLoading] = useState(false);
const [app, setApp] = useState([]);
const searchRef = useRef(null);
const [loading, setLoading] = useState(false);
const [userid,setUserID] = useState(0);
const [inputValue, setInput] = useState("");

const [selectvoice,setVoice] = useState(null);
const [selectLang,setLanguage] = useState(null);
const [ivrdata,setIvrData] = useState("");

const [order, setOrder] = useState('asc'); 
const [orderBySelector, setOrderBySelector] = useState(() => (row) => row.rid); 
const [globalFilterText, setGlobalFilterText] = useState('');
const [columnFilters, setColumnFilters] = useState({});
const [types,setType]= useState(0);
const [jobDescription,setJobDescription]= useState("");
const [dstteam,setSelectTeam] = useState([]);

  const voice = [
    { value: '1', label: 'KAJAL' },
    { value: '3', label: 'RAJ' },
    { value: '5', label: 'ANKITA' },
    { value: '4', label: 'YASH' },
    { value: '2', label: 'PRIYA' }
  ];

  const lanugage = [
    { value: '2', label: 'HINDI' },
    { value: '1', label: 'ENGLISH' }
  ];
 
const[headingTitle,setheadingTitle] = useState('');
  const [metaData, setMetaData] = useState({
    typess: '',
    bd:false,check:false,manager:false,
    dstCheck:false,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0); // Set this from your API response
  const limit = 50; 
  const maxPage = Math.ceil(totalRows / limit);
  const [fileInfo, setFileInfo] = useState(null);
  

  const fetchData = async (page) => {
    $("#showLoader").removeClass('d-none').addClass('d-flex');
    const response = await axios.get(apiurl + 'allotement.php?reid=react&page='+page+"&value="+aid+"&campType="+campType+"&new=1"); // Replace with your API endpoint
    
    setStaff(response.data.staff || []);
    setTEam(response.data.team || []);
    setStats(response.data.stats || []);
    setTotalRows(response.data.total_count);
   
    setMetaData({
      typess: response.data.typess,
      bd:response.data.bd,
      check:response.data.check,
      manager:response.data.manager,
      dstCheck:response.data.dstCheck
    });
    $("#showLoader").removeClass('d-flex').addClass('d-none');
  };

const dynamicFilterOptions = useMemo(() => {
const options = {};
const selectAccessors = ['location','smstatus','dststatus','shstatus'];

selectAccessors.forEach(key => {
  const uniqueValues = new Set();
  staff.forEach(row => {
      if (row[key]) {
          uniqueValues.add(row[key]);
      }
  });
  options[key] = Array.from(uniqueValues).sort();
});
return options;
}, [staff]);

const shouldIncludeActionColumn = (
metaData.typess?.toUpperCase() === "ADMIN" || metaData.typess?.toUpperCase() === "VENDOR" ||
metaData.del === 1 ||
metaData.view === 1 ||
metaData.add === 1 ||
metaData.edit === 1 ||
metaData.bd === 1
);
  

  const EditData = async (edit, sss) => {
    if (edit) {
      $("#showLoader").removeClass('d-none').addClass('d-flex');
      try {
        let url = "";

    // 🔹 Case 1 → Requirement
    if (sss == 1) {
      url = apiurl + 'requirement.php?edit=' + edit;
      setDetail([]);
    }

    // 🔹 Case 2 → Allotement (Paid)
    if (sss == 2) {
      url = apiurl + 'allotement.php?paid_cid=' + edit;
    }
        const response = await axios.get(url);
        
        if (response.data.status == true) {
     
      if (sss == 2) {
        setDetail(response.data.data2[0]);
      }
            setRequirement(response.data.data[0]);
            $("#table_modal").click();
     
          $("#showLoader").removeClass('d-flex').addClass('d-none');
        } else {
          // modal can't show
          $("#showLoader").removeClass('d-flex').addClass('d-none');
          alert("data not found");
        }

      }
      catch (error) {
        console.error('Error deleting category:', error);
      }

    }

  };

  const updateDetails = async (idd,val) => { 
    if(val === "1" || val === "3"){
       $("#showLoader").removeClass('d-none').addClass('d-flex');
       
       if(val==="1"){
         setUserID(idd);
         $("#tera_modal2").click();
       }
       else{
          $("#bulkmodal").click();
          setUserID(idd);
       }
       $("#showLoader").removeClass('d-flex').addClass('d-none');
    }
    
    else if(val === "2" || val === "22" || val === "30" || val === "33"){
       $("#showLoader").removeClass('d-none').addClass('d-flex');
       try{
         const response = await axios.get(apiurl + 'ivr.php?com=' + idd + "&value=" + val);
        
         if(response.data.status === true){
            $("#tera_modal3").click();
            setIvr(idd);
            setIvrData(response.data.main[0]);
          
            setheadingTitle(response.data.main[0].val==='2' || response.data.main[0].val==='30' ? 'Start IVR Campaign' : 'SENT TO DST');
            setType(response.data.main[0].val);
            setJobDescription(response.data.main[0].jobDescription);
         }
         else{
          Swal.fire({
            position: "top-center",
            icon: "error",
            title: "Something Went Wrong !",
            showConfirmButton: false,
            timer: 2000
          });
         }
       }
       catch (error) {
        console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
       }
       finally {
         $("#showLoader").removeClass('d-flex').addClass('d-none');
       }
     }
  };

  const isQuillEmpty = (value) => {
    if (value === null || value === undefined) return true;
    const html = String(value).trim();
    if (!html) return true;
    const text = html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/\u00a0/g, " ")
      .trim();
    return text.length === 0;
  };

  const UpdateForm = async (e) => {
    e.preventDefault();
   const selectedStatus = e?.target?.elements?.status?.value || "";
   if (selectedStatus !== "1" && isQuillEmpty(inputValue)) {
     alert("Please enter remark");
     return false;
   }
    // try and catch method
     $("#showLoader").removeClass('d-none').addClass('d-flex');
     
    try {
      const formData = new FormData($("#updateForm")[0]);
      formData.append("campaign", inputValue);
       formData.append("requireid", aid);
       formData.append("camptype",campType);
     const response = await axios.post(apiurl + "allotement.php", formData);
     
     
      if (response.data.status == true) {
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $(".modal .btn-close").click();
          fetchData(currentPage);
        });
      }
      else {
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
       $("#showLoader").removeClass('d-flex').addClass('d-none');
    }

  
  };

const displayCount = 5;
let startPage = Math.max(1, currentPage - Math.floor(displayCount / 2));
let endPage = startPage + displayCount - 1;

if (endPage > maxPage) {
    endPage = maxPage;
    startPage = Math.max(1, endPage - displayCount + 1);
}

const pages = [];
for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
}

  useEffect(() => {
    document.title = isCampaignCandidateLineup ? "Campaign Candidate Line Up | MERAQUI" : "Campaign Request List | MERAQUI";
    fetchData(currentPage);
    $('#modalclose').on('click', function () {
      $("#hidden").val("");
      $("#reset").click();
    });


    $('.appCloseModal').on('click', function () {
      setApp([]);
     
    });

  }, [aid,campType,refreshKey,currentPage,isCampaignCandidateLineup]);


const IvrFORM = async (e) =>{
       e.preventDefault();
    
    if (campType !== '1' && campType !== '2') {
        console.log("IVR Submission attempted. Aborting.");
        return; 
    }
    
    $("#showLoader").removeClass('d-none').addClass('d-flex');
     
    try {
      const formData = new FormData($("#submitform")[0]);
      if(types==='2' || types=='30'){
      formData.append("voice", selectvoice);
      formData.append("lang", selectLang);
      }
      else{
        formData.append("dstteam",dstteam);
      }
      formData.append("aid",aid);
      formData.append('campid',ivrdata.campid);
      formData.append("newjob",jobDescription);
      formData.append("ivrrid",ivrdata.hidden);
      formData.append("ivrType",types);
      formData.append("ctablehidden",ivrdata.ctablehidden);
      const response = await axios.post(apiurl + "ivr.php", formData);
     
      if (response.data.status === true) {
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $(".offcanvas .btn-close").click();
          fetchData(currentPage);
        });
      }
      else {
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
      
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
       $("#showLoader").removeClass('d-flex').addClass('d-none');
    }
};

const RenderStatusChip = ({ status ,rowId, statusType}) => {
    
    const value = status?.toLowerCase();
    const popoverRef = useRef(null);
    
    const remarkMap = {
        'sm_status': 'sm_remark',
        'sh_status': 'sh_remark',
        'dst_status': 'dst_remark',
    };

    const statustime = {
        'sm_status': 'sm_time',
        'sh_status': 'sh_time',
        'dst_status': 'dst_time',
    };
    
    const remarkField = remarkMap[statusType] || ''; 
    const remarkContent = (remarkField && rowId[remarkField]) || 'No remark available.';
    
    useEffect(() => {
        if (popoverRef.current) {
            if (window.bootstrap && window.bootstrap.Popover) {
                const existingPopover = window.bootstrap.Popover.getInstance(popoverRef.current);
                if (existingPopover) {
                    existingPopover.dispose();
                }
                new window.bootstrap.Popover(popoverRef.current, {
                    content: remarkContent,
                    placement: 'left', // You can change placement (top, bottom, right, auto)
                    trigger: 'focus', // Dismiss popover on next click outside
                    html: true,       // Allow HTML content (optional)
                    customClass: 'status-remark-popover', 
                });
            } else {
                console.error("Bootstrap JavaScript (specifically Popover) is not loaded.");
            }
        }
        return () => {
            if (popoverRef.current && window.bootstrap && window.bootstrap.Popover) {
                const popoverInstance = window.bootstrap.Popover.getInstance(popoverRef.current);
                if (popoverInstance) {
                    popoverInstance.dispose();
                }
            }
        };
    }, [remarkContent,remarkField]);

    let color = "default";
    let label = "Unknown";
    let sx = {};

    switch (value) {
        case "pending":
            color = "warning";
            label = "Processing";
            break;
        case "success":
            color = "success";
            label = "Approved";
            break;
        case "decline":
            color = "danger";
            label = "Rejected";
            break;
    }
    const rootClassName = `badge bg-${color}-transparent`;
    return (
      <>
        <span className={rootClassName}>{label} </span>
           <i 
            ref={popoverRef} // Attach the ref
            className="ti ti-eye ms-2 text-info" 
            style={{ cursor: 'pointer' }} 
            // Use standard Bootstrap data attributes for the Popover trigger
            data-bs-toggle="popover" 
            data-bs-title={`Remark for ${label}`} 
            tabIndex="0" // Makes the icon focusable for trigger: 'focus'
            role="button"
            title="View Remark"
        ></i>
        <br/>
        <span>{rowId[statustime[statusType]]}</span>
      </>
    );
};


const CustomRequested = ({ row }) => {
    const rowData = row;
 return (
    <Button
      sx={{
        p: 0,
        minWidth: 0,
        textAlign: 'left',
        textTransform: 'none',
        alignItems: 'flex-start',
        '&:hover': { backgroundColor: 'transparent' }
      }}
    >
      <Box sx={{ lineHeight: 1.2 }}>
        <Typography
          sx={{
            fontSize: '0.9rem',
            fontWeight: 600,
          }}
        >
          {rowData.recruiter}
        </Typography>

     {rowData.userpost && (
        <Typography
          sx={{
            fontSize: '0.75rem',
            color: '#6B7280',
          }}
        >
          {rowData.userpost}
        </Typography>
       )}
      </Box>
    </Button>
  );
};


const RenderActionStatusCell = ({ rowData, metaData, updateDetails,campType }) => {
  let classString = "";
  
  if(campType==='1' || campType==='2'){ 
    const bd = Number(metaData.bd);
    const baseClass = "btn btn-sm"; 
    let classString = "";

    if (rowData.main?.toLowerCase() === "decline") {
        classString = `${baseClass} btn-danger`;
        return (
            <Button variant="contained" size="small" color="error" className={classString}>
                All Rejected
            </Button>
        );
    }
   
  if(campType=='2'){
    if(rowData.self==='1'){
      if(rowData.ivr?.toLowerCase() === "success"){ 
         classString = `${baseClass} btn-success`;
            return (
              <div style={{ display: "flex", gap: "8px" }}>
             
                <Button variant="contained" size="small" color="success" className={classString} onClick={(e) => { e.stopPropagation(); navigate(`/admin/dstcandidate/${rowData.id}/1001`); }}>
                    View Candidates
                </Button>
              </div>
            );
          } 
       else{
        classString = `${baseClass} btn-warning`;
        return (
            <Button variant="contained" size="small" color="success" className={classString}>
                Processing 
            </Button>
        );
       }
    }
     else if(bd!= 3 && bd!=33 && rowData.dst?.toLowerCase() === "success"){
        classString = `${baseClass} ` + (rowData.ivr?.toLowerCase() === "success" ? 'btn-success' : 'btn-warning');
        return (
            <Button variant="contained" size="small" color="success" className={classString}>
                {rowData.ivr?.toLowerCase() === "success" ? 'IVR Completed' : 'IVR Processing'}
            </Button>
        );
     }
  }
    if ((bd === 3 || bd=== 33) && rowData.main?.toLowerCase() === "success") {
      classString = `${baseClass} btn-info`;
       
     if(campType==='1'){
        if(rowData.ivr?.toLowerCase() === "success"){
            classString = `${baseClass} btn-success`;
            return (
                <Button variant="contained" size="small" color="success" className={classString} onClick={(e) => { e.stopPropagation(); navigate(`/admin/dstcandidate/${rowData.id}/101`); }}>
                    View Candidates
                </Button>
            );
        }
        else{
            return (
              <>
            <Button
                variant="contained"
                size="small"
                color="info"
                onClick={(e) => { e.stopPropagation(); updateDetails(rowData.id, "2"); }}
                className={classString} // Apply class here
            >
                IVR RUN
            </Button>
            <br/><br/>
            <Button
                variant="contained"
                size="small"
                color="info"
                onClick={(e) => { e.stopPropagation(); updateDetails(rowData.id, "22"); }}
                className={classString} // Apply class here
            >
                SENT TO DST
            </Button>
            </>
        );
      }
      }
     else if(rowData.dst?.toLowerCase() === "success" && rowData.main?.toLowerCase() === "success"){
         if(rowData.ivr?.toLowerCase() === "success"){
            classString = `${baseClass} btn-success`;
            return (
              <div style={{ display: "flex", gap: "8px" }}>
             
                <Button variant="contained" size="small" color="success" className={classString} onClick={(e) => { e.stopPropagation(); navigate(`/admin/dstcandidate/${rowData.id}/1001`); }}>
                    View Candidates
                </Button>
              </div>
            );
        }
        else if(rowData.ustatus?.toLowerCase() === "success"){
            return (
              <>
            <Button
                variant="contained"
                size="small"
                color="info"
                onClick={(e) => { e.stopPropagation(); updateDetails(rowData.id, "30"); }}
                className={classString} // Apply class here
            >
                IVR RUN
            </Button>
            <br/><br/>
            <Button
                variant="contained"
                size="small"
                color="info"
                onClick={(e) => { e.stopPropagation(); updateDetails(rowData.id, "33"); }}
                className={classString} // Apply class here
            >
                SENT TO DST
            </Button>
            </>
        );
      }
      else{
        return (
            <Button
                variant="contained"
                size="small"
                color="info"
                onClick={(e) => { e.stopPropagation();updateDetails(rowData.id,"3")}}
                className={classString} // Apply class here
            >
                Upload Candidates
            </Button>
        );
      }
      }
 
    }    
    let statusToCheck = "";
    let isWait = false;
    
    if (bd === 1) {
        statusToCheck = rowData.sm;
    } else if (bd === 2) {
        if (rowData.sm?.toLowerCase() === "pending") {
            isWait = true;
        }
        statusToCheck = rowData.sh;
    } else if (bd === 3) {
        if (rowData.sh?.toLowerCase() === "pending") {
            isWait = true;
        }
        statusToCheck = rowData.dst;
    }

    // 3. Wait status (Disabled)
    if (isWait) {
        classString = `${baseClass} btn-warning`;
        return (
            <Button variant="contained" size="small" color="warning" className={classString}>
                Wait..
            </Button>
        );
    }

    // 4. Update Status (Pending, Actionable) or UPDATED (Success, Disabled)
    const isPending = statusToCheck?.toLowerCase() === "pending";
    
    if (isPending) {
        classString = `${baseClass} btn-primary`;
        return (
            <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={(e) => { e.stopPropagation(); updateDetails(rowData.id, "1"); }}
                className={classString} // Apply class here
            >
                Update Status
            </Button>
        );
    } else {
        classString = `${baseClass} btn-warning`;
        return (
            <Button variant="contained" size="small" color="success" className={classString}>
                Wait 
            </Button>
        );
    }
  }
  else{
    classString = `btn btn-sm btn-info`;
    const tt= rowData.type=='OPEN' ? '301' : '302';
     return (
            <Button
                variant="contained"
                size="small"
                color="info"
                onClick={(e) => { e.stopPropagation();navigate(`/admin/candidate/${rowData.id}/${tt}`);}}
                className={classString} // Apply class here
            >
                {rowData.type} Campaign LINE UP
            </Button>
        );
  }
  
};

const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

const getComparator = (order, orderBy) => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};

const descendingComparator = (a, b, orderBy) => {
    const valA = orderBy(a);
    const valB = orderBy(b);

    if (valB < valA) {
        return -1;
    }
    if (valB > valA) {
        return 1;
    }
    return 0;
};

const ColumnHeaderWithFilter = ({ 
    column, 
    orderBySelector, 
    order, 
    handleRequestSort, 
    columnFilters, 
    setColumnFilters,
}) => {

    const [localOpenKey, setLocalOpenKey] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [tempFilter, setTempFilter] = useState("");

    const accessorKey = column.accessorKey;

    const isMenuOpen = localOpenKey === accessorKey;
    const currentFilter = String(columnFilters[accessorKey] || '');
    const isSorted = orderBySelector === column.selector;

    useEffect(() => {
        setTempFilter(currentFilter);
    }, [currentFilter]);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setLocalOpenKey(accessorKey);
        setTempFilter(currentFilter);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setLocalOpenKey(null);
    };

    const handleFilterChange = (e) => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: e.target.value
        }));
    };

    const handleTempChange = (e) => {
        setTempFilter(e.target.value);
    };

    const applySearch = () => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: tempFilter
        }));
        handleClose();
    };

    const isSortable = !!column.selector;
    const isFilterable = !!column.filterType;

    // --- Custom Filter Input Renderer ---
    const renderFilterInput = () => {

        if (column.filterType === 'select') {

            const filterOptions = column.dynamicFilterOptions || [];

            return (
                <MuiSelect
                    label={`Filter ${column.header}`}
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    sx={{ width: '100%' }}
                >
                    <MenuItem value="">— All —</MenuItem>
                    {filterOptions.map(option => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                </MuiSelect>
            );
        }

        if (column.filterType === 'date') {
            return (
                <TextField
                    label={`Filter ${column.header}`}
                    type="date"
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    InputLabelProps={{ shrink: true }}
                    sx={{ width: '100%' }}
                />
            );
        }

        // Default: text filter (with Search button)
        return (
            <>
                <TextField
                    label={`Filter ${column.header}`}
                    variant="outlined"
                    size="small"
                    value={tempFilter}
                    onChange={handleTempChange}
                    autoFocus
                    sx={{ width: '100%' }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            applySearch();
                        }
                    }}
                />

                <Button
                    variant="contained"
                    size="small"
                    onClick={applySearch}
                    sx={{ mt: 1, textTransform: 'none', width: "100%" }}
                >
                    Search
                </Button>
            </>
        );
    };


    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                '& .MuiTableSortLabel-root': { flexGrow: 1 }
            }}
        >
            <TableSortLabel
                active={isSorted}
                direction={isSorted ? order : 'asc'}
                onClick={() => isSortable && handleRequestSort(column.selector)}
                IconComponent={isSorted ? (order === 'desc' ? ArrowDropDown : ArrowDropUp) : undefined}
                sx={{
                    cursor: isSortable ? 'pointer' : 'default',
                    justifyContent: column.headerAlign === 'center' ? 'center' : 'flex-start',
                    '&.Mui-active': {
                        color: 'primary.main',
                        fontWeight: 'bold',
                    }
                }}
            >
                {column.header}
            </TableSortLabel>

            {isFilterable && (
                <>
                    <IconButton
                        aria-label="filter"
                        size="small"
                        onClick={handleClick}
                        sx={{
                            ml: 1,
                            p: 0,
                            color: currentFilter ? 'primary.main' : 'text.secondary',
                        }}
                    >
                        <MoreVertIcon fontSize="inherit" />
                    </IconButton>

                    <Menu
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        onClose={handleClose}
                        onClick={(e) => e.stopPropagation()}
                        PaperProps={{
                            sx: { width: 250, p: 1, boxShadow: 6, borderRadius: 2 }
                        }}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >

                        <Box sx={{ width: '100%', p: 1 }}>
                            {renderFilterInput()}
                        </Box>

                        {currentFilter && (
                            <Button
                                onClick={() => {
                                    setColumnFilters(prev => ({
                                        ...prev,
                                        [accessorKey]: ''
                                    }));
                                    handleClose();
                                }}
                                size="small"
                                color="error"
                                sx={{ mt: 1, textTransform: 'none', width: "100%" }}
                            >
                                Clear Filter
                            </Button>
                        )}

                    </Menu>
                </>
            )}
        </Box>
    );
};


const columns = useMemo(() => {

let baseColumns = [
  { accessorKey: 'rid', header: 'Req. ID', size: 150, selector: (row) => row.requireds, filterType: 'text', headerAlign: 'center' },
  { accessorKey: 'campid', header: 'Campaign ID', size: 150, selector: (row) => row.campid, filterType: 'text' },
  { accessorKey: 'name', header: 'Client Name', size: 150, selector: (row) => row.client, filterType: 'text' },
  { 
      accessorKey: 'Location', 
      header: 'Location', 
      size: 150, 
      selector: (row) => row.location, 
      filterType: 'select',
      dynamicFilterOptions: dynamicFilterOptions['location']
  },
{ 
      accessorKey: 'date', 
      header: 'Request Time', 
      size: 150, 
      selector: (row) => row.dates, 
      filterType: 'date' 
  },

];

if(["3"].includes(campType)){
  baseColumns.push(  { 
      accessorKey: 'type', 
      header: 'Campaign Type', 
      size: 150, 
      selector: (row) => row.type, 
      filterType: 'select',
      dynamicFilterOptions: dynamicFilterOptions['type']
  },
);
}

if ( metaData.check === 1) {
  baseColumns.push({
      accessorKey: 'recruiter',
      header: 'Requested By',
      size: 150,
      selector: (row) => row.recruiter,
  });
}

if(["1", "2"].includes(campType)){
  baseColumns.push(  { 
      accessorKey: 'sm_status', 
      header: 'SM STATUS', 
      size: 180, 
      selector: (row) => row.sm, 
      filterType: 'select',
      dynamicFilterOptions: dynamicFilterOptions['smstatus']
  },
  
  { 
      accessorKey: 'sh_status', 
      header: 'SH Status', 
      size: 180, 
      selector: (row) => row.sh, 
      filterType: 'select',
      dynamicFilterOptions: dynamicFilterOptions['shstatus']
  },
  { 
      accessorKey: 'dst_status', 
      header: 'DST Status', 
      size: 180, 
      selector: (row) => row.dst, 
      filterType: 'select',
      dynamicFilterOptions: dynamicFilterOptions['dststatus']
  }
);
}

if (metaData.typess?.toUpperCase() === "STAFF" && ["1", "2", "3","33"].includes(metaData.bd)) {
baseColumns.push({
  accessorKey: 'bd_action',
  header: 'Action',
  selector: (row) => row.main,
  sortable: true,
  Cell: ({ row: { original } }) => (
      <RenderActionStatusCell 
          rowData={original} 
          metaData={metaData} 
          updateDetails={updateDetails}
          campType={campType}
      />
  ),
});
}

return baseColumns;
}, [metaData.check, dynamicFilterOptions, shouldIncludeActionColumn, metaData.typess, metaData.bd, updateDetails,campType]);

const handleRequestSort = useCallback((selector) => {
const isAsc = orderBySelector === selector && order === 'asc';
setOrder(isAsc ? 'desc' : 'asc');
setOrderBySelector(() => selector);
}, [order, orderBySelector]);

const processedData = useMemo(() => {
let filtered = staff;
const lowerCaseFilter = globalFilterText.toLowerCase();

// 1. Apply Global Filter
if (lowerCaseFilter) {
  filtered = filtered.filter(row => 
      columns.some(column => {
          const value = column.selector ? String(column.selector(row)) : '';
          return value.toLowerCase().includes(lowerCaseFilter);
      })
  );
}

// 2. Apply Column Filters
filtered = filtered.filter(row => {
  return columns.every(column => {
      const accessorKey = column.accessorKey;
      const filterValue = columnFilters[accessorKey];

      if (!filterValue) return true;
      if (!column.selector) return true;

      const rowValue = String(column.selector(row));

      switch (column.filterType) {
          case 'select':
              // Must match the selected value exactly
              return rowValue === filterValue; 
              
          case 'date':
              // Check if the date string (e.g., '2024-01-15') includes the filter date
              return rowValue.includes(filterValue); 
              
          case 'text':
          default:
              return rowValue.toLowerCase().includes(filterValue.toLowerCase());
      }
  });
});

// 3. Sorting Logic
const sortColumn = columns.find(col => col.selector === orderBySelector);

if (sortColumn) {
  return stableSort(filtered, getComparator(order, sortColumn.selector));
}

return filtered;

}, [staff, columns, order, orderBySelector, globalFilterText, columnFilters]);


const RenderReqIdCell = useCallback(({ row }) => {
    const rowData = row;
    const isViewDetailClickable = true; // Set to true or use metaData.view check if needed
   
    let statsColor = '#10B981'; let idTooltipContent = 'Requirement In-process';
    if (rowData.rstatus.toLowerCase() === 'onhold') {
        statsColor = '#F59E0B'; idTooltipContent='Requirement Onhold';
    } else if (rowData.rstatus.toLowerCase() === 'closed') {
        statsColor = '#9CA3AF'; idTooltipContent='Requirement Closed';
    }
 return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' ,width:150}}>

           <Tooltip title={isViewDetailClickable ? 'View Detail' : ''} arrow>
                <IconButton
                    size="small"
                    onClick={() => EditData(campType=='1' ? rowData.reqidhidden : rowData.id, campType == '1' ? 1 : 2)} 
                    sx={{
                        color: 'orange', 
                        p: 0.5,
                        '&:hover': {
                            color: isViewDetailClickable ? '#0056b3' : 'text.disabled',
                            backgroundColor: 'transparent'
                        }
                    }}
                >
                    <VisibilityOutlined sx={{ fontSize: '1rem' }} />
                </IconButton>
            </Tooltip>

{(campType==='1' || campType==='2') &&(
   <Tooltip title="Download Candidates" arrow>
        <IconButton
            size="small"
            onClick={() => {window.location=`${apiurl}dst_candidate.php?subdomain=react&export=xls&aid=${rowData.id}&aidtype=${campType=='1' ? '101' : '1001  '}`;}} 
            sx={{
                color: '#1976d2',
                p: 0.5,
                '&:hover': {
                    color: '#0d47a1',
                    backgroundColor: 'transparent'
                }
            }}
        >
            <DownloadOutlined sx={{ fontSize: '1rem' }} />
        </IconButton>
    </Tooltip>
)}
 
             <Tooltip title={idTooltipContent} arrow>
                <Button
                    sx={{
                        background: "none",
                        border: "none",
                        color: statsColor, // Use status color for the ID text
                         padding: 0,
                        minWidth: 0, 
                        fontWeight: 500,
                        textAlign: 'left',
                        textTransform: 'none',
                        fontSize: '0.875rem',
                        '&:hover': { backgroundColor: 'transparent' }
                    }}
                >
                    {rowData.requireds}
                </Button>
            </Tooltip>
            
        </Box>
    );
}, [navigate, EditData,campType]);

const BulkFormSubmit = async (e) =>{
          e.preventDefault();
          // try and catch method
            try {
              const formData = new FormData($("#bulkForm")[0]);
              if($("#bulk").val().length==0){
                Swal.fire({
                       position:'top-center',
                       icon:'question',
                       title:"Please select the bulk candidate file"
                   });
                   return false;
              }
              
              $("#showLoader").removeClass("d-none").addClass("d-flex");
              const response = await axios.post(apiurl + "dst_candidate.php", formData);
if (response.data.status === true) {

  setResults({
  alreadyExist: response.data.already || [],
  duplicate: response.data.duplicate || [],
  unique: response.data.unique || []
});

      setShowResultsModal(true);

      $("#bulkModal .btn-close").click();
      $("#bulkForm input").val("");
      fetchData(currentPage);

               }
              else{
                Swal.fire({
                  position: "top-center",
                  icon: "error",
                  title: response.data.messages || "no",
                  showConfirmButton: false,
                  timer: 2000
                  });
              }
               $("#showLoader").removeClass("d-flex").addClass("d-none");
            } catch (error) {
              console.log(error.response?.data?.message); // Handle errors with informative messages
            }
};

const BulkUploadResultsModal = ({ show, onClose, results = {} }) => {
const safeResults = results || {};
const { alreadyExist = [], duplicate = [], unique = [] } = safeResults;

useEffect(() => {
if (show) {
  document.body.style.overflow = "hidden";
} else {
  document.body.style.overflow = "";
}
return () => (document.body.style.overflow = "");
}, [show]);

if (!show) return null;

const SummaryRow = ({ label, count, colorClass }) => (
<div className="me-3 d-flex align-items-center">
  <span
    className={`badge ${colorClass} rounded-pill me-2`}
    style={{ minWidth: 28 }}
  >
    {count}
  </span>
  <small className="text-muted">{label}</small>
</div>
);

const Table = ({ title, items, emptyMessage }) => (
<div className="mb-3">
  <h6 className="mb-2">
    {title} <small className="text-muted">({items.length})</small>
  </h6>
  <div className="table-responsive" style={{ maxHeight: "360px", overflowY: "auto" }}>
    <table className="table table-hover table-sm align-middle">
      <thead className="table-light sticky-top">
        <tr>
          <th style={{ width: "6%" }}>#</th>
          <th style={{ width: "34%" }}>Name</th>
          <th style={{ width: "24%" }}>Mobile</th>
          <th style={{ width: "30%" }}>Email</th>
          <th style={{ width: "6%" }} className="text-end">
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        {items.length === 0 ? (
          <tr>
            <td colSpan={5} className="text-center text-muted py-4">
              {emptyMessage}
            </td>
          </tr>
        ) : (
          items.map((it, idx) => (
            <tr key={`${it.mobile}-${idx}`}>
              <td>{idx + 1}</td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: 220,
                }}
                title={it.name}
              >
                {it.name || "-"}
              </td>
              <td>{it.mobile || "-"}</td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: 260,
                }}
                title={it.email}
              >
                {it.email || "-"}
              </td>
              <td className="text-end">
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => navigator.clipboard?.writeText(it.mobile || "")}
                  title="Copy mobile"
                >
                  Copy
                </button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
</div>
);

return (
<>
<div className="bulk-results-modal">
  <div className="modal-backdrop fade show"></div>
  <div className="modal d-block fade show" tabIndex={-1} role="dialog" aria-modal="true">
    <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div className="modal-content shadow-lg rounded-3">
        <div className="modal-header">
          <div>
            <h5 className="modal-title">Bulk Upload — Results</h5>
            <div className="d-flex mt-1">
              <SummaryRow label="Added (unique)" count={unique.length} colorclass="bg-success text-white" />
              <SummaryRow label="Duplicates in CSV" count={duplicate.length} colorclass="bg-warning text-dark" />
              <SummaryRow label="Already in Database" count={alreadyExist.length} colorclass="bg-secondary text-white" />
            </div>
          </div>
          <div>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
        </div>

        <div className="modal-body">
          <ul className="nav nav-tabs mb-3" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="nav-link active" data-bs-target="#added" id="tab-added" data-bs-toggle="tab" type="button" role="tab" aria-controls="added" aria-selected="true">Added</button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="tab-duplicate" data-bs-target="#duplicate" data-bs-toggle="tab" type="button" role="tab" aria-controls="duplicate" aria-selected="false">Duplicates</button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="tab-already" data-bs-target="#already" data-bs-toggle="tab" type="button" role="tab" aria-controls="already" aria-selected="false">Already in DB</button>
            </li>
          </ul>

          <div className="tab-content">
            <div className="tab-pane fade show active" id="added" role="tabpanel" aria-labelledby="tab-added" style={{overflowX:'auto'}}>
              <Table title="Unique / Inserted into database" items={unique} emptyMessage="No new records were inserted." />
            </div>
            <div className="tab-pane fade" id="duplicate" role="tabpanel" aria-labelledby="tab-duplicate" style={{overflowX:'auto'}}>
              <Table title="Duplicates found in CSV (skipped)" items={duplicate} emptyMessage="No duplicate mobiles found in CSV." />
            </div>
            <div className="tab-pane fade" id="already" role="tabpanel" aria-labelledby="tab-already" style={{overflowX:'auto'}}>
              <Table title="Already present in database (skipped)" items={alreadyExist} emptyMessage="No existing mobiles found in DB." />
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <div className="me-auto text-muted small">
            Total rows shown: {unique.length + duplicate.length + alreadyExist.length}
          </div>
          <button className="btn btn-outline-secondary" onClick={() => {
            const allRows = [
              ["type", "name", "mobile", "email"],
              ...unique.map((i) => ["added", i.name, i.mobile, i.email]),
              ...duplicate.map((i) => ["duplicate", i.name, i.mobile, i.email]),
              ...alreadyExist.map((i) => ["already", i.name, i.mobile, i.email]),
            ];
            const csv = allRows.map(r => r.map(c => '"' + String(c || "").replace(/\"/g,'""') + '"').join(',')).join('\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'bulk-upload-results.csv';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
          }}>Download CSV</button>
          <button className="btn btn-primary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  </div>

  {newloading && (
    <div className="loader-overlay">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  )}

  <style jsx>{`
    .modal-backdrop { z-index: 1040; }
    .modal { z-index: 1050; }
    .table thead.sticky-top { top: 0; }
    .loader-overlay {
      position: fixed;
      top:0; left:0; right:0; bottom:0;
      background: rgba(255,255,255,0.7);
      display:flex;
      justify-content:center;
      align-items:center;
      z-index:2000;
    }
  `}</style>
</div>
</>
);

};


const handleFileChange2 = (e) => {
const file = e.target.files[0];
if (!file) return;

setFileInfo({
name: file.name,
size: (file.size / 1024).toFixed(2) // KB
});
};


  return (
    <>
      <BulkUploadResultsModal show={showResultsModal} onClose={() => setShowResultsModal(false)} results={results}/>

      <button data-bs-toggle="modal" id="tera_modal2" data-bs-target="#allModal" type="button" style={{ display: 'none' }}></button>
      
      <button data-bs-toggle="modal" id="tera_modal" data-bs-target="#exampleModalFullscreen" type="button" style={{ display: 'none' }}></button>
      <button data-bs-toggle="modal" id="table_modal" data-bs-target="#tableModal" type="button" style={{ display: 'none' }}></button>

   {( (campType==='1' || campType=='2') && metaData.dstCheck===1) && ( 
      <>
      <button data-bs-toggle="modal" id="bulkmodal"  data-bs-target="#bulkModal" type="button" style={{ display: 'none' }}></button>
      <button data-bs-toggle="offcanvas" id="tera_modal3" data-bs-target="#exampleModal" type="button" style={{ display: 'none' }}></button>
      <div className="offcanvas offcanvas-top" style={{ maxHeight: '100%', height: 'auto', backgroundColor: 'rgb(245 245 245)' }} tabIndex="-1" id="exampleModal" >
        <div className="offcanvas-header border-bottom border-block-end-dashed">
          <h5 className="offcanvas-title" id="offcanvasRightLabel1">{headingTitle}</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="modalclose" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body" style={{ paddingBottom: '80px' }}>
          <div className='d-flex'>

            <form id="submitform" onSubmit={IvrFORM} encType="multipart/form-data" className='order-2'>
             <div className="row g-3">
               <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="organName" className="form-label">Campaign Id</label>
                  <input value={ivrdata.campid || ""} type="text" className="form-control" placeholder="Campaign ID" readOnly disabled/>
                </div>
                 <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="organName" className="form-label">Requirement Id</label>
                  <input value={ivrdata.requireid || ""} name='requireid' type="text" className="form-control" placeholder="Require ID" readOnly disabled/>
                </div>
                
                <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="organName" className="form-label">Client Name</label>
                  <input value={ivrdata.client || ""} type="text" className="form-control" placeholder="Organisation name" readOnly  disabled/>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="skills" className="form-label">Location</label>
                  <input  value={ivrdata.location || ""}  type="text" className="form-control" placeholder="Location"  readOnly  disabled/>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="short" className="form-label">Job Title</label>
                  <input  defaultValue={ivrdata.jobTitle || ""} type="text" name='newTitle' className="form-control" placeholder="JOB TITLE"  />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="detail" className="form-label">MIN EXP.</label>
                  <input  defaultValue={ivrdata.expFrom || ""}  type="text" name='newMinExp' className="form-control" placeholder="Min Experience"  />
                </div>
                 <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="detail" className="form-label">MAX EXP.</label>
                  <input defaultValue={ivrdata.expTo || ""}  type="text" name='newMaxExp' className="form-control" placeholder="MAX Experience"  />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="name" className="form-label">Min Salary</label>
                  <input defaultValue={ivrdata.ctcFrom || ""}  type="text" name='newMinSalary' className="form-control" placeholder="MIN SALARY"  />
                </div>
                 <div className="col-lg-6">
                  <label htmlFor="name" className="form-label">Max Salary</label>
                  <input defaultValue={ivrdata.ctcTo || ""}  type="text" name='newMaxSalary' className="form-control" placeholder="MAX SALARY" />
                <div className='col-12'>
                       <label htmlFor="jobDescription" className="form-label">JOB DESCRIPTION</label>
                       <ReactQuill  value={jobDescription}  onChange={setJobDescription} theme="snow" modules={{ toolbar: false }} style={{maxHeight:'300px', minHeight:'50px',border: "1px solid darkgrey", borderRadius: '10px' }}/>
                </div>
                </div>

<style jsx>{`
  .ql-container {
    height: auto !important;
    min-height: 50px; 
  }
  .ql-editor {
    min-height: 50px;
    max-height: 300px; 
    overflow-y: auto;
  }
`}</style>

              <div className='col-lg-6'>
                <div className="row g-3">
             {types==='2' || types=='30' ? (
<>
                <div className="col-6">
                  <label htmlFor="organName" className="form-label"><span className='text-danger fs-15'>*</span>Organisation name</label>
                  <input id="organName" name="organName" type="text" className="form-control" placeholder="Organisation name" required />
                </div>
                <div className="col-6">
                  <label htmlFor="skills" className="form-label">SKILLS</label>
                  <input id="skills" name="skills" type="text" className="form-control" placeholder="Skills" />
                </div>
                <div className="col-6">
                  <label htmlFor="short" className="form-label">Organisation Short Description</label>
                  <input id="short" name="short" type="text" className="form-control" placeholder="Short Description" />
                </div>
                <div className="col-6">
                  <label htmlFor="detail" className="form-label">Organisation Detailed Description</label>
                  <input id="detail" name="detail" type="text" className="form-control" placeholder="Detail Description" />
                </div>
                <div className="col-6">
                  <label htmlFor="name" className="form-label">Name</label>
                  <input id="name" name="names" type="text" className="form-control" placeholder="Name" />
                </div>
                <div className="col-6">
                  <label htmlFor="caller" className="form-label"><span className='text-danger fs-15'>*</span>Caller name</label>
                  <input id="caller" name="caller" type="text" className="form-control" placeholder="Caller Name"  required/>
                </div>
                <div className="col-6">
                  <label htmlFor="mobile" className="form-label"><span className='text-danger fs-15'>*</span>CALLER MOBILE NUMBER</label>
                  <input id="mobile" name="mobile" type="text" className="form-control" placeholder="Mobile Number" required />
                </div>

                               <div className="col-6">
                                  <label htmlFor="lanugage" className="form-label"><span className='text-danger fs-15'>*</span>Language Id</label>
                                  <Select
                                    options={lanugage || []}
                                    value={(lanugage || []).find(opt => opt.value === selectLang) || null}
                                    onChange={(option) => setLanguage(option ? option.value : null)}
                                    placeholder="Select Language" onMenuOpen={() => {}}
                                  />
                                </div>
                      <div className="col-6">
                                      <label htmlFor="voice" className="form-label"><span className='text-danger fs-15'>*</span>CAMPAGIN VOICE ID</label>
                                      <Select
                                        options={voice || []}
                                        value={(voice || []).find(opt => opt.value === selectvoice) || null}
                                        onChange={(option) => setVoice(option ? option.value : null)}
                                        placeholder="Select Voice Id" onMenuOpen={() => {}}
                                      />
                     </div>
           </>    
           
             ) : (
              <>
                 <div className="col-12">
                                  <label htmlFor="clientName" className="form-label"><span className='text-danger fs-15'>*</span>DST TEAM</label>
                                  <Select
                                          options={team}   // must be an array
                                          isMulti
                                          closeMenuOnSelect={false}
                                          value={team.filter(opt => dstteam.includes(opt.value))}
                                          onChange={(options) => setSelectTeam(options.map(opt => opt.value))}
                                          placeholder="Select DST"
                                        />
                </div>
              </>
             )}
              
                <div className='col-12' style={{
                  padding: "7px 20px",
                  textAlign: "right",
                  position: "fixed",
                  bottom: 0,
                  right: 0,
                  background: "#fff",
                  boxShadow: "-4px -4px 4px darkgrey",
                }}>
                  <input type="hidden" name="hidden" value={ivr} />
                  <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
                  <button type="submit" className="btn btn-primary">Submit</button>
                </div>
              </div>

              </div>
              </div>
            </form>

          </div>

        </div>

      </div>
      <div className="modal effect-flip-horizontal fade" id="bulkModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="bulkModal" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Select File</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form id="bulkForm" onSubmit={BulkFormSubmit}>
              <div className="modal-body">

                <div className="row g-3">
                  <div className="col-lg-6" style={{display:'flex',width:'100%'}}>
                                    <button className="btn btn-sm btn-danger" onClick={()=>{window.location=`${process.env.REACT_APP_EXPORT_URL}demo/download.php?tt=1`;}} type="button">Sample Bulk File Download</button>
                                    <button className="btn btn-sm btn-info" style={{marginLeft:'20px'}} onClick={()=>{window.location=`${process.env.REACT_APP_EXPORT_URL}demo/download.php?tt=2`;}} type="button">CSV File Steps PDF</button>
                    </div>


                <div className='col-12'>
                  <p className="form-label">Scan File</p>
                      <input id="bulk" style={{display:'none'}}  accept=".csv" name="bulk" className="form-control" autoComplete='off' type='file' defaultValue="" onChange={handleFileChange2}/>
                    <label htmlFor="bulk"  className='form-label' style={{width:'60px',height:'60px',textAlign:'center',alignContent:'center',border:'2px solid',borderColor:'rgb(var(--primary-rgb))!important'}}>
                           <i className='ri-qr-scan-2-line' style={{fontSize:'25px'}}></i>
                      </label>
                   {fileInfo && (
                            <div style={{marginTop:'10px',float:'left'}}>
                              <div style={{ fontWeight: "500" }}>{fileInfo.name}</div>
                              <small style={{ color: "#6c757d" }}>
                                {(fileInfo.size / 1024).toFixed(2)} MB
                              </small>
                            </div>
                          )}
                </div>
                  <div className="col-lg-12" style={{ textAlign: 'right' }}>
                    <input type="hidden" name='hidden' value={userid}/>
                    <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
                  </div>
                </div>

              </div>
              <div className='modal-footer' style={{ padding: '0px' }}>
                <button type="submit" className="btn btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      </>
      )}

    <div className="modal effect-super-scaled fade" id="tableModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="tableModal" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-body" style={{maxHeight:'90vh',overflowX:'auto'}}>
  
  {campType=='2' &&   (
    <>
   <h3 style={{fontSize:'19px',marginBottom:'18px'}}><strong>Paid Campaign Details</strong></h3>

    <table className="table table-bordered" style={{ tableLayout: "fixed" }}>
  <tbody>
    {detail && [
      ["Pay Roll", "Domain", "Industry", "Campaign ID",
        detail.payroll,
        detail.domain,
        detail.industry,
        detail.campid
      ],
      ["City", "State", "Country", "Interview Date/Time",
        detail.jobCity,
        detail.jobState,
        detail.jobCountry,
        detail.interviewDateTime
      ],
      ["Qualification", "Skills", "Other Benefits", "Concern Person",
        detail.specifyQualification,
        detail.skills,
        detail.otherBenefits,
        detail.concernPerson
      ],
      ["Contact No", "Sourcing Location", "SPOC ID", "SPOC Name",
        detail.contactNo,
        detail.sourcingLocation,
        detail.spocPersonIdEditable,
        detail.spocPersonName
      ],
      ["Business Head", "Recruiting Fee", "Question", "Shift Time",
        detail.businessHead,
        detail.recruitingFee,
        detail.question,
        detail.shiftTime
      ]
    ].map((row, idx) => (
      <React.Fragment key={idx}>
        {/* Heading Row */}
        <tr>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[0]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[1]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[2]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[3]}</th>
        </tr>

        {/* Value Row */}
        <tr>
          <td>{row[4] || "-"}</td>
          <td>{row[5] || "-"}</td>
          <td>{row[6] || "-"}</td>
          <td>{row[7] || "-"}</td>
        </tr>
      </React.Fragment>
    ))}
  </tbody>
</table>
    </>
    )}
<>
<h5 style={{fontSize:'19px',marginBottom:'18px',marginTop:'20px'}}><strong>Requirement Detail</strong></h5>

<table className="table table-bordered" style={{ tableLayout: "fixed" }}>
  <tbody>
{requirement && (
    <>
    <tr>
       <th style={{ backgroundColor: "#e9ecef" }}>Keywords</th>
        <td colSpan="4">{requirement.keywords || "N/A"}</td>
    </tr>
    <tr>
      <th>Job Description</th>
      <td colSpan="4">
  {requirement.jobDescription ? (
    <div
    style={{
              maxHeight: "350px",
              overflowY: "auto",
              padding: "15px",
              background: "#f8f9fa",
              borderRadius: "6px",
              lineHeight: "1.6",
              fontSize: "14px"
            }}
      dangerouslySetInnerHTML={{
        __html: requirement.jobDescription,
      }}
    />
  ) : (
    "N/A"
  )}
</td>

    </tr>
    </>
    )}
    {requirement && [
      ["RecID", "Branch", "CTC From", "CTC To", requirement.rid, requirement.branchh, requirement.ctcFrom,requirement.ctcTo],
      ["Gender", "RecName", "Age", "Requirement Plan Dates", requirement.gender?.toUpperCase(), requirement.recname, requirement.ageFrom+" to "+requirement.ageTo, requirement.planFromDate+" to "+requirement.planToDate],
      ["Client Name", "Anchor", "Location", "Experience", requirement.cidd, requirement.anchor, requirement.location, requirement.expFrom+" To "+requirement.expTo],
      ["Education Type", "Commercials", "Designation", "Contact Name", requirement.education, requirement.commercials, requirement.posts, requirement.contactName],
      ["Contract", "Placement Type", "Job Title", "Requirement Status", requirement.contract, requirement.placementType, requirement.jobTitle, requirement.statuses],
      ["Cost Center", "Requirement Create Time", "No Of Position", "Pincode", requirement.costCenterbig, requirement.datestimes, requirement.noOfPosition, requirement.pincode],
    ].map((row, idx) => (
      <React.Fragment key={idx}>
        {/* Headings Row */}
        <tr>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[0]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[1]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[2]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[3]}</th>
        </tr>

        {/* Values Row */}
        <tr>
          <td>{row[4] || "-"}</td>
          <td>{row[5] || "-"}</td>
          <td>{row[6] || "-"}</td>
          <td>{row[7] || "-"}</td>
        </tr>
      </React.Fragment>
    ))}
    
  </tbody>
</table>
</>
  

 </div>
            <div className='modal-footer' style={{ padding: '0px' }}>
              <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal" id="okayClose" aria-label="Close">Close</button>
            </div>
          </div>
        </div>
      </div>


      <div className="modal effect-flip-horizontal fade" id="allModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="allModal" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="allModal">Update Status</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" id="okayClose" aria-label="Close"></button>
            </div>
            <form id="updateForm" onSubmit={UpdateForm}>
              <div className="modal-body">

                <div className="row g-3">
                  <div className="col-lg-12" >
                    <label className='form-label' style={{width:'100%'}}>Status</label>
                    <div className='d-flex gap-4'>
                    <div className="form-check form-check-md">
                                        <input className="form-check-input" type="radio" value='1' name="status" id="Radio-md" required/>
                                        <label className="form-check-label" for="Radio-md">
                                            Accept
                                        </label>
                                    </div>
                                    <div className="form-check form-check-md">
                                        <input className="form-check-input" type="radio" value='2' name="status" id="Radio-ms" required/>
                                        <label className="form-check-label" for="Radio-ms">
                                            Reject
                                        </label>
                                    </div>
                      </div>
                   </div>
                  <div className="col-lg-12" >
                    <ReactQuill
                      theme="snow"
                      value={inputValue} onChange={setInput}
                      style={{ maxHeight: "300px", overflowX: 'auto', border: "1px solid darkgrey", borderRadius: '10px' }}
                    />
                  </div>
                  <div className="col-lg-12" style={{ textAlign: 'right' }}>
                    <input type="hidden" name='hidden' value={userid}/>
                    <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
                  </div>
                </div>

              </div>
              <div className='modal-footer' style={{ padding: '0px' }}>
                <button type="submit" className="btn btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="main-content app-content">

        <div className="container-fluid">

 <div className="row">

<div class="col-xl-12 mt-4">
    <div class="card custom-card">
        <div class="card-header" style={{justifyContent:'space-between',display:'flex'}}>
          <div class="card-title">{isCampaignCandidateLineup ? 'Campaign Candidate Line Up' : `${campType==='1' ? 'Open' : 'Paid'} Campaign Summary`}</div>
        {/* OPEN CAMPAIGN BUTTON */}
          {metaData.manager === '33' && (
          <>
           {(campType==='1') && (
              <button
                className="btn btn-primary text-nowrap"
                onClick={() => navigate(`/admin/selflineup/${aid}/1`)}
              >
                OPEN CAMPAIGN Request
              </button>
           )}

           {(campType==='2') && (
              <button
                className="btn btn-primary text-nowrap"
                onClick={() => navigate(`/admin/selflineup/${aid}/2`)}
              >
                PAID CAMPAIGN Request
              </button>
           )}
           </>
          )}
          <div style={{display:'flex'}}>
                      <Tooltip title="Download Candidates Data" arrow>
                      <IconButton
                        size="medium"
                        onClick={() => {
                          window.location = `${apiurl}download.php?subdomain=react&export=xls&aid=${aid}&aidtype=${campType}`;
                        }}
                        sx={{
                          color: '#fff',
                          background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
                          borderRadius: '10px',
                          p: 1,
                          boxShadow: '0 4px 12px rgba(25, 118, 210, 0.35)',
                          transition: 'all 0.25s ease',
                          '&:hover': {
                            background: 'linear-gradient(135deg, #0d47a1, #1976d2)',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 6px 16px rgba(13, 71, 161, 0.45)',
                          },
                          '&:active': {
                            transform: 'scale(0.95)',
                          },
                        }}
                      >
                        <DownloadOutlined sx={{ fontSize: '1.4rem' }} />
                      </IconButton>
                    </Tooltip>
                    
                      <button className="btn btn-primary ms-2" onClick={() => navigate(isCampaignCandidateLineup ? `/admin/lineup/${aid}` : -1)}>Back</button>
                      </div>
        </div>
        <div class="card-body">
            <div class="row gy-md-0 gy-3">

 {stats.map((item, index) => (
 
 <div class="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12" key={index}>
                    <div class="d-flex align-items-top">
                        <div class="me-3">
                            <span class={"avatar avatar-rounded text-white"} style={{backgroundColor:item.color}}>
                                <i class={`${item.icon} fs-28`}></i>
                            </span>
                        </div>
                        <div>
                            <span class="d-block mb-1 text-muted">{item.label}</span>
                            <h6 class="fw-semibold mb-0">{item.count}</h6>
                        </div>
                    </div>
                </div>

  ))}

            </div>
        </div>
    </div>
</div>
</div>
  

<div className="row">
            <div className="col-xxl-12 col-xl-12 ">
              <div className="card custom-card">
                <div className="card-header justify-content-between" style={{ paddingBottom: '15px', alignItems: 'normal' }}>
                  <div>
                    <h6 className="fs-16">Campaign List</h6>
                  </div>
                  <div className="d-flex mt-sm-0 mt-2 align-items-center">

                    <div className="input-group" >
                      <input type="search" className="form-control" placeholder="Search Campaign" id="search-member"  value={globalFilterText}
                    onChange={(e) => setGlobalFilterText(e.target.value)} />
                    </div>
        </div>

                </div>
                <div className="card-body" style={{ padding: '0px' }}>

           <TableContainer>
                <Table stickyHeader aria-label="requirement tracker table">
                    
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.accessorKey}
                                    sx={{ 
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        p: 2.5,
                                        fontSize: '0.85rem', 
                                        verticalAlign: 'top',
                                    }}>
                                    <ColumnHeaderWithFilter
                                        column={column}
                                        orderBySelector={orderBySelector}
                                        order={order}
                                        handleRequestSort={handleRequestSort}
                                        columnFilters={columnFilters}
                                        setColumnFilters={setColumnFilters}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>


 <TableBody>
    {processedData.map((row, index) => (
       <TableRow
  key={index}
  sx={{
    backgroundColor:
      campType === '3'
        ? row.type === "PAID"
          ? "#e3f2fd"   // PAID color (blue-ish)
          : "#f3e5f5"   // OPEN color (purple-ish)
        : row.ivr === "success"
          ? "#e8f5e9"
          : row.dst === "decline"
            ? "#ffebee"
            : row.dst === "pending"
              ? "#fff3e1"
              : "inherit",
  }}
>
            {columns.map((column) => {
                let cellContent;const cellWidth = column.size ? column.size : 150;
                  
                switch (column.accessorKey) {
                    case 'rid':
                        cellContent = <RenderReqIdCell row={row} />; 
                        break;
                   case 'recruiter':
                         cellContent = <CustomRequested row={row}/>
                        break;
                   
                    case 'sm_status':
                    case 'sh_status':
                    case 'dst_status':
                        const statusValue = column.selector(row);
                        cellContent = <RenderStatusChip status={statusValue} rowId={row} statusType={column.accessorKey}/>;
                        break;
                        
                    case 'bd_action':
                        cellContent = (
                            <RenderActionStatusCell 
                                rowData={row} 
                                metaData={metaData} 
                                updateDetails={updateDetails} // <-- Pass the handler
                                campType={campType}
                            />
                        );
                        break;
                        
                    default:
                        const value = column.selector ? column.selector(row) : null;
                        cellContent = value;
                        break;
                }

                return (
                    <TableCell 
                        key={column.accessorKey}
                        sx={{ p: 1.5, fontSize: '0.875rem',minWidth:cellWidth,width:cellWidth}}>
                        {cellContent}
                    </TableCell>
                );
            })}
        </TableRow>
    ))}
    
    {/* Empty state if no data */}
    {processedData.length === 0 && (
        <TableRow>
            <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                <Typography color="textSecondary" variant="body1">
                    No matching found in the current filters.
                </Typography>
            </TableCell>
        </TableRow>
    )}
</TableBody>
               
            </Table></TableContainer>
          
                </div>
                <div className="card-footer d-flex align-items-center justify-content-between" style={{ padding: '10px 25px' }}>
    <p className="text-muted mb-0">
        Showing <strong>{((currentPage - 1) * limit) + 1}</strong> – <strong>{Math.min(currentPage * limit, totalRows)}</strong> of <strong>{totalRows}</strong> entries
    </p>

    <nav aria-label="Page navigation">
        <ul className="pagination mb-0">
            {/* First Page */}
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(1)}>« First</button>
            </li>

            {/* Previous */}
            <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>&laquo;</button>
            </li>

            {/* Dynamic Page Numbers */}
            {pages.map(pageNum => (
                <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(pageNum)}>
                        {pageNum}
                    </button>
                </li>
            ))}

            {/* Next */}
            <li className={`page-item ${currentPage >= maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>&raquo;</button>
            </li>

            {/* Last Page */}
            <li className={`page-item ${currentPage === maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(maxPage)}>Last »</button>
            </li>
        </ul>
    </nav>
                </div>
              </div>

            </div>
          </div>


        </div>
      </div>

    </>
  );
};
export default CampaignList;
